import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useCallback, Fragment, useMemo } from 'react';
import { NavMarker } from 'react-rhumb';
import styled from 'styled-components';
import I18n from 'I18n';
import getLang from 'I18n/utils/getLang';
import unescapedText from 'I18n/utils/unescapedText';
import CanonicalLink from 'ecosystem-marketplace-core/components/elements/CanonicalLink';
import HrefLangLink from 'marketplace-ui-common/components/elements/HrefLangLink';
import MetaDescription from 'ecosystem-marketplace-core/components/elements/MetaDescription';
import MetaOpenGraph from 'ecosystem-marketplace-core/components/elements/MetaOpenGraph';
import MetaTwitter from 'ecosystem-marketplace-core/components/elements/MetaTwitter';
import DocumentHead from 'ecosystem-marketplace-core/components/portals/DocumentHead';
import PrerenderReady from 'ecosystem-marketplace-core/components/prerender/PrerenderReady';
import { getFullPublicUrl } from '../utils/urls';
import usageTracker from '../utils/usageTracker';
import MarketplaceCardsSection, { CARD_BUTTON_HEIGHT } from '../components/MarketplaceCardsSection';
import AssetMarketplaceSection from '../components/AssetMarketplaceSection';
import AppMarketplaceSection from '../components/AppMarketplaceSection';
import SolutionsDirectorySection from '../components/SolutionsDirectorySection';
import ProviderSignupSection from '../components/ProviderSignupSection';
import HeaderSection, { HEADER_PADDING_Y } from '../components/HeaderSection';
import { HOME_SECTION_Y_PADDING } from '../components/HomeSection'; // @ts-expect-error image

import twitterImageUrl from 'bender-url!../../img/screenshot-twitter.png'; // @ts-expect-error image

import openGraphImageUrl from 'bender-url!../../img/screenshot-og.png';
import CmsFreeSection from '../components/CmsFreeSection';
const HEADER_PADDING_BOTTOM = CARD_BUTTON_HEIGHT / 2 + HEADER_PADDING_Y;
const LANGS = ['en', 'de', 'es', 'fr', 'ja', 'pt'];
const TOP_SECTION_PADDING = CARD_BUTTON_HEIGHT / 2 + HOME_SECTION_Y_PADDING;
const StyledCmsFreeSection = styled(CmsFreeSection).withConfig({
  displayName: "Home__StyledCmsFreeSection",
  componentId: "swrivm-0"
})(["padding-top:", "px;"], TOP_SECTION_PADDING); // TODO refactor once HrefLangLink is converted

export default function Home() {
  const lang = getLang();
  const canonicalUrl = getFullPublicUrl(lang);
  const metaDescription = unescapedText('marketplaceUnified.metaDescription');
  const renderedHrefLangLinks = useMemo(() => {
    const hrefLangConfigs = [{
      href: getFullPublicUrl('en'),
      isDefault: true,
      lang: 'en'
    }, ...LANGS.map(_lang => ({
      href: getFullPublicUrl(_lang),
      isDefault: false,
      lang: _lang
    }))];
    return hrefLangConfigs.map(({
      href,
      isDefault,
      lang: _lang
    }) => /*#__PURE__*/_jsx(HrefLangLink, {
      href: href,
      lang: _lang,
      "x-default": isDefault
    }, `href-lang-${isDefault ? 'default' : _lang}`));
  }, []);
  const trackInteraction = useCallback((action, eventProps = {}) => {
    usageTracker.track('interaction', Object.assign({
      screen: 'homepage',
      action
    }, eventProps));
  }, []);
  useEffect(() => {
    usageTracker.track('pageView', {
      screen: 'homepage'
    });
  }, []);
  useEffect(() => {
    document.title = I18n.text('marketplaceUnified.htmlTitle');
  }, []);
  return /*#__PURE__*/_jsxs(NavMarker, {
    name: "INDEX_LOAD",
    children: [/*#__PURE__*/_jsx(DocumentHead, {
      children: /*#__PURE__*/_jsxs(Fragment, {
        children: [/*#__PURE__*/_jsx(MetaDescription, {
          content: metaDescription
        }), /*#__PURE__*/_jsx(MetaTwitter, {
          name: "card"
        }), /*#__PURE__*/_jsx(MetaTwitter, {
          name: "site"
        }), /*#__PURE__*/_jsx(MetaTwitter, {
          name: "image",
          content: twitterImageUrl
        }), /*#__PURE__*/_jsx(MetaOpenGraph, {
          property: "type"
        }), /*#__PURE__*/_jsx(MetaOpenGraph, {
          property: "url",
          content: canonicalUrl
        }), /*#__PURE__*/_jsx(MetaOpenGraph, {
          property: "description",
          content: metaDescription
        }), /*#__PURE__*/_jsx(MetaOpenGraph, {
          property: "image",
          content: openGraphImageUrl
        }), /*#__PURE__*/_jsx(CanonicalLink, {
          href: canonicalUrl
        }), renderedHrefLangLinks, /*#__PURE__*/_jsx(PrerenderReady, {})]
      })
    }), /*#__PURE__*/_jsx(HeaderSection, {
      paddingBottom: HEADER_PADDING_BOTTOM
    }), /*#__PURE__*/_jsxs("main", {
      children: [/*#__PURE__*/_jsx(MarketplaceCardsSection, {
        onTrackInteraction: trackInteraction
      }), /*#__PURE__*/_jsx(StyledCmsFreeSection, {
        onTrackInteraction: trackInteraction
      }), /*#__PURE__*/_jsx(AssetMarketplaceSection, {
        onTrackInteraction: trackInteraction
      }), /*#__PURE__*/_jsx(AppMarketplaceSection, {
        onTrackInteraction: trackInteraction
      }), /*#__PURE__*/_jsx(SolutionsDirectorySection, {
        onTrackInteraction: trackInteraction
      }), /*#__PURE__*/_jsx(ProviderSignupSection, {
        onTrackInteraction: trackInteraction
      })]
    })]
  });
}